import { createSelector } from "reselect"
import lodash from "lodash"

const state = s => s.Orders

export const selectId = (_, props) => {
  return lodash.get(props, "match.params.id")
}

export const selectError = createSelector(state, s => s.error)

export const makeSelectOrder = () => createSelector(state, state => state.order)

export const makeSelectIsLoading = () =>
  createSelector(state, state => state.isLoading)

export const makeSelectFilterClean = () =>
  createSelector(makeSelectFilterForm(), filter => {
    return {
      ...filter,
      filter: filter.filter.filter(filter => {
        return filter.value !== ""
      })
    }
  })

export const makeSelectItem = () =>
  createSelector([selectId, makeSelectItemsById()], (id, items) => {
    const result = lodash.get(items, id)
    const item = {
      ...result,
      receiver: {
        name1: result.receiverName1,
        name2: result.receiverName2,
        name3: result.receiverName3,
        street: result.receiverStreet,
        streetNumber: result.receiverStreetNumber,
        streetNumberAddition: result.receiverStreetNumberAddition,
        city: result.receiverCity,
        zip: result.receiverZip,
        country: result.receiverCountry
      },
      sender: {
        name1: result.senderName1,
        name2: result.senderName2,
        name3: result.senderName3,
        street: result.senderStreet,
        streetNumber: result.senderStreetNumber,
        streetNumberAddition: result.senderStreetNumberAddition,
        city: result.senderCity,
        zip: result.senderZip,
        country: result.senderCountry
      },
      invoice: {
        name1: result.invoiceName1,
        name2: result.invoiceName2,
        name3: result.invoiceName3,
        street: result.invoiceStreet,
        streetNumber: result.invoiceStreetNumber,
        streetNumberAddition: result.invoiceStreetNumberAddition,
        city: result.invoiceCity,
        zip: result.invoiceZip,
        country: result.invoiceCountry
      },
    }

    return item
  })
